import { render } from "./GoogleFormIframe.vue?vue&type=template&id=6503c720&scoped=true"
import script from "./GoogleFormIframe.vue?vue&type=script&lang=js"
export * from "./GoogleFormIframe.vue?vue&type=script&lang=js"

import "./GoogleFormIframe.vue?vue&type=style&index=0&id=6503c720&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6503c720"]])

export default __exports__